import {Button} from '@chekinapp/ui';
import dayjs from 'dayjs';
import i18n from 'i18next';
import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {Calendar, QrCode} from 'lucide-react';
import {AlertBox} from '@chekin/guestapp-ui-kit';
import {usePath} from 'hooks';
import {PATHS} from 'routes/constants';
import {useReservation} from 'context/reservation';
import styles from './styles.module.css';

function IVUnavailableView() {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {getFullPath} = usePath();
  const {data: reservation} = useReservation();

  const handleBackToSummary = useCallback(() => {
    navigate(getFullPath(PATHS.guestRegistration), {replace: true});
  }, [navigate, getFullPath]);

  const checkInDate = reservation?.check_in_date
    ? dayjs(reservation.check_in_date)
        .utc()
        .format(i18n.language === 'pt' ? 'DD [de] MMMM YYYY' : 'DD MMMM YYYY')
    : null;

  return (
    <div className={styles.ivUnavailable_content}>
      <div className={styles.ivUnavailable_iconBox}>
        <QrCode size={48} className={styles.ivUnavailable_icon} strokeWidth={1.5} />
      </div>

      <h2 className={styles.ivUnavailable_title}>{t('verification_unavailable')}</h2>

      <div className={styles.ivUnavailable_reasonBox}>
        <div className={styles.ivUnavailable_reasonHeading}>
          <Calendar size={20} className={styles.ivUnavailable_reasonIcon} />
          <p className={styles.ivUnavailable_reasonTitle}>
            {t('outside_check_in_period')}
          </p>
        </div>

        <p className={styles.ivUnavailable_reasonDescription}>
          {t('iv_only_available_on_check_in_day')}
        </p>

        {checkInDate && (
          <p className={styles.ivUnavailable_checkInDate}>
            <span>{t('check_in_date') + ':'}</span>
            <strong>{checkInDate}</strong>
          </p>
        )}

        <AlertBox text={t('iv_note_id_and_camera_required')} />
      </div>

      <Button
        onClick={handleBackToSummary}
        className={styles.ivUnavailable_button}
        variant="outline"
      >
        {t('back_to_summary')}
      </Button>
    </div>
  );
}

export {IVUnavailableView};
